import {createAction, props} from "@ngrx/store";
import {FilterKeyValuePairInterface, PaginationInfoInterface, TrumpfCompanyModel} from "../../interfaces";

export const addTrumpfCompany = createAction("[TrumpfCompany] Add TrumpfCompany", props<{trumpfCompany: TrumpfCompanyModel}>());

export const addTrumpfCompanies = createAction(
  "[TrumpfCompany] Add TrumpfCompanies",
  props<{trumpfCompanies: Array<TrumpfCompanyModel>}>()
);

export const updateTrumpfCompany = createAction(
  "[TrumpfCompany] Update TrumpfCompany",
  props<{trumpfCompany: TrumpfCompanyModel}>()
);

export const setTrumpfCompanies = createAction(
  "[TrumpfCompany] Set TrumpfCompanies",
  props<{trumpfCompanies: Array<TrumpfCompanyModel>}>()
);

export const setPaginatedTrumpfCompanies = createAction(
  "[TrumpfCompany] Set Paginated TrumpfCompanies",
  props<{trumpfCompanies: Array<TrumpfCompanyModel>}>()
);

export const setTrumpfCompaniesPaginationInfo = createAction(
  "[TrumpfCompany] Set PaginationInfo",
  props<{paginationInfo: PaginationInfoInterface}>()
);

export const gotoTrumpfCompaniesPage = createAction("[TrumpfCompany] Goto Page", props<{page: number}>());

export const applyTrumpfCompaniesFilters = createAction(
  "[TrumpfCompany} Apply Filter",
  props<{filters: Array<FilterKeyValuePairInterface>}>()
);

export const resetTrumpfCompaniesFilters = createAction("[TrumpfCompany] Reset Filters");
